import { httpClient } from "../network/httpclient/HttpClientFactory";

const specList = (siteId) =>
  httpClient.get(`/material/spec/${siteId}/spec-list`).then((res) => res.data);

export default {
  specList,
};
